function isEmptyCondition(condition: any): boolean {
  return Object.keys(condition).length === 0;
}

function flattenAndConditions(conditions: any[]): any[] {
  const flattened: any[] = [];

  for (const condition of conditions) {
    if (isEmptyCondition(condition)) {
      continue;
    }

    const normalized = normalizeMongoQuery(condition);
    if (isEmptyCondition(normalized)) {
      continue;
    }

    if (
      '$and' in normalized &&
      Array.isArray(normalized.$and) &&
      Object.keys(normalized).length === 1
    ) {
      flattened.push(...normalized.$and);
      continue;
    }

    flattened.push(normalized);
  }

  return flattened;
}

function flattenOrConditions(conditions: any[]): any[] {
  const flattened: any[] = [];

  for (const condition of conditions) {
    const normalized = normalizeMongoQuery(condition);
    if (isEmptyCondition(normalized)) {
      continue;
    }

    if (
      '$or' in normalized &&
      Array.isArray(normalized.$or) &&
      Object.keys(normalized).length === 1
    ) {
      flattened.push(...normalized.$or);
      continue;
    }

    flattened.push(normalized);
  }

  return flattened;
}

export function normalizeMongoQuery(query: any): any {
  if (isEmptyCondition(query)) {
    return {};
  }

  if ('$and' in query && Array.isArray(query.$and)) {
    const flattened = flattenAndConditions(query.$and);

    if (!flattened.length) {
      return {};
    }
    if (flattened.length === 1) {
      return flattened[0];
    }
    return { $and: flattened };
  }

  if (
    '$or' in query &&
    Array.isArray(query.$or) &&
    Object.keys(query).length === 1
  ) {
    const flattened = flattenOrConditions(query.$or);

    if (!flattened.length) {
      return {};
    }
    if (flattened.length === 1) {
      return flattened[0];
    }
    return { $or: flattened };
  }

  return query;
}

export function combineMongoAndConditions(conditions: any[]): any {
  const flattened = flattenAndConditions(conditions);

  if (!flattened.length) {
    return {};
  }
  if (flattened.length === 1) {
    return flattened[0];
  }
  return { $and: flattened };
}
